import snsWebSdk from '@sumsub/websdk'

function getNewAccessToken() {
  return Promise.resolve(`${process.env.SUM_SUB_TOKEN}`)
}

/**
 * @param selector
 * @param apiUrl - 'https://test-api.sumsub.com' (sandbox)
 or 'https://api.sumsub.com' (production)
 * @param accessToken - access token that you generated on the backend in Step 2
 * @param applicantEmail - applicant email (not required)
 * @param applicantPhone - applicant phone, if available (not required)
 * @param customI18nMessages - customized locale messages for current session (not required)
 */
// eslint-disable-next-line
export function launchWebSdk(
  // eslint-disable-next-line
  this: any,
  selector: string,
  apiUrl: string,
  accessToken: string,
  applicantEmail?: string,
  applicantPhone?: string,
  customI18nMessages?: string,
) {
  return new Promise((resolve, reject) => {
    const snsWebSdkInstance = snsWebSdk
      .init(accessToken, () => getNewAccessToken())
      .withBaseUrl(apiUrl)
      .withConf({
        lang: 'en', // languge of WebSDK texts and comments (ISO 639-1 format)
        email: applicantEmail,
        phone: applicantPhone,
        i18n: customI18nMessages,
        uiConf: {
          customCssStr:
            ':root {\n  --black: #000000;\n   --grey: #F5F5F5;\n  --grey-darker: #B2B2B2;\n  --border-color: #DBDBDB;\n}\n\np {\n  color: var(--black);\n  font-size: 16px;\n  line-height: 24px;\n}\n\nsection {\n  margin: 40px auto;\n}\n\ninput {\n  color: var(--black);\n  font-weight: 600;\n  outline: none;\n}\n\nsection.content {\n  background-color: var(--grey);\n  color: var(--black);\n  padding: 40px 40px 16px;\n  box-shadow: none;\n  border-radius: 6px;\n}\n\nbutton.submit,\nbutton.back {\n  text-transform: capitalize;\n  border-radius: 6px;\n  height: 48px;\n  padding: 0 30px;\n  font-size: 16px;\n  background-image: none !important;\n  transform: none !important;\n  box-shadow: none !important;\n  transition: all 0.2s linear;\n}\n\nbutton.submit {\n  min-width: 132px;\n  background: none;\n  background-color: var(--black);\n}\n\n.round-icon {\n  background-color: var(--black) !important;\n  background-image: none !important;\n}',
          // URL to css file in case you need change it dynamically from the code
          // the similar setting at Applicant flow will rewrite customCss
          // you may also use to pass string with plain styles `customCssStr:`
        },
      })
      .withOptions({ addViewportTag: false, adaptIframeHeight: true, debug: false })
      // eslint-disable-next-line
      .on('idCheck.onError', (error: any) => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          status: 'error',
          message: 'WebSDK onError',
          stackTrace: {
            ...error,
          },
        })
      })
      // eslint-disable-next-line
      .onMessage((type: any, payload: any) => {
        // see below what kind of messages the WebSDK generates
        /**
       * [Docs](https://developers.sumsub.com/web-sdk/#websdk-messages)
       payload {
             attemptCnt: 0
             attemptId: "VVmxL"
             autoChecked: false
             createDate: "2021-08-19 15:14:09+0000"
             levelName: "basic-kyc-level"
             priority: 0
             reprocessing: false
             reviewId: "hxBYN"
             reviewStatus: "pending"
           }
       */
        if (payload?.reviewStatus) {
          resolve({
            status: 'success',
            message: 'WebSDK onMessage',
            type,
            payload,
          })
        }
      })
      .build()

    // you are ready to go:
    // just launch the WebSDK by providing the container element for it
    snsWebSdkInstance.launch(selector)
  })
}
